import React, {PropTypes} from 'react';
import { getScreen, resetClicked } from '../../../actions/screenAction';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenContainer from '../Subcomponents/ScreenContainer';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import FieldGroup from '../Subcomponents/FieldGroup';
import ActionButton from '../Subcomponents/ActionButton';

class EnterPin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            pinIsValid: false};
        this.getNextScreen = this.getNextScreen.bind(this);
        this.AskForNewPin = this.AskForNewPin.bind(this);
        this.updateState = this.updateState.bind(this);     
    }

    updateState(event) {       
        let stateUpdate = {};
        stateUpdate[event.target.name] = event.target.value;

        let isValid =  event.target.value.length > 0 ? true : false;
        this.setState({pinIsValid: isValid});

        return this.setState(stateUpdate);
    }

    getNextScreen () {
        let currentState = {
            Values: this.state
        };
        this.props.actions.getScreen(currentState, this.props.name);
    }

    AskForNewPin(event) {
      event.preventDefault();
      this.props.actions.resetClicked(this.props.name);
    }    

    render() {
        let textResources = this.props.textResources;

        return (
            <ScreenContainer>
                    <ScreenHeader title={textResources.HeaderTitle} text={textResources.HeaderText} icon={this.props.uiSpec.Icon} />
                    <ScreenInstructions title={textResources.InstructionTitle} text={textResources.InstructionText}/>
                    <div className="o-pageSection o-pageSection--form">
                        <FieldGroup errorText={textResources.IncorectPin} valid={!this.props.uiSpec.PinInvalid} label={textResources.PinLabel}>
                            <input name="pin" type="text" className="c-Input" placeholder={textResources.PinPlaceholder} onChange={this.updateState}/>
                        </FieldGroup>

                        <div className="o-buttonContainer u-align-center vivo-pinscreen">
                            <ActionButton action={this.getNextScreen} valid={this.state.pinIsValid} text={textResources.ContinueButtonText} />
                        </div>

<p className="font-size-small line-height-2 dark-gray textAligh-center">{textResources.AskForANewPinText}
    <a className="font-size-small vivo-blue-links" href="#" onClick={this.AskForNewPin}>{textResources.AskForANewPinLink}</a>.
</p>
                    </div>
                </ScreenContainer>
            );
    }
}

EnterPin.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getScreen, resetClicked}, dispatch)
  };
}

function mapStateToProps(state, ownProps){
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterPin);



/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Vivo/VivoEnterPin.js
 **/